import React, { Grid, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "services";
import { CoreRoutes } from "app-constants";
import { EmailConfirmationProps } from "./EmailConfirmationFormProps";

export const EmailConfirmationForm = ({ email, token }: EmailConfirmationProps) => {
    const [message, setMessage] = useState<string>('Confirming email...');
    const navigate = useNavigate();
    const handleEmailConfirmation = async (email: string | null, token: string | null): Promise<boolean> => {
        try {
            if (email === null || token === null) {
                return false;
            }
            return await AuthService.confirmEmail(email, token);
        } catch (error) {
            return false;
        }
    };
    useEffect(() => {
        handleEmailConfirmation(email, token).then(result => {
            if (result) {
                navigate(CoreRoutes.login);
            } else {
                setMessage('Failed to confirm email. Please try again.');
            }
        });
    }, [email, token, navigate]);

    return (
        <div style={{ width: '35%', height: '80%' }}>
            <Grid container justifyContent='center' textAlign={'center'} spacing={2} component={Paper} p={5}>
                <Typography variant={'h4'}>{message}</Typography>
            </Grid>
        </div>
    );
}